import Vue from 'vue'
import Vuex from 'vuex'

import home from './Home/index'
import login from './Login/index'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    home,
    login
  }
})
